import React from 'react';
import { Button, ButtonProps, Text } from '@cardboard-ui/react';
import { FormQuestionType, QuestionIcon } from 'components/icons/QuestionIcon';
import { t } from '@lingui/macro';

export const DEFAULT_QUESTION_TITLE = () => t`Ask a question`;

interface CreateQuestionButtonProps extends ButtonProps {
  questionType?: FormQuestionType;
  icon?: React.ReactElement;
  text: string;
}

export const CreateQuestionButton = ({
  questionType,
  icon,
  text,
  ...props
}: CreateQuestionButtonProps) => {
  return (
    <Button
      size="sm"
      variant="ghost"
      {...props}
      leftIcon={
        icon || <QuestionIcon questionType={questionType} color="blue.500" />
      }
    >
      <Text>{text}</Text>
    </Button>
  );
};
